import { Injectable } from '@angular/core';
import readXlsxFile from 'read-excel-file';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BANCOS } from 'src/app/components/casos/ver-tarea/constants/bancos.constant';
import { HEADER_EXCEL_CASES_RESUME } from '../constants/constants-data-xlsx';
import { CaseService } from '../../case/services/case.service';
import { ICase } from '../../cases/interfaces/case.interface';

@Injectable({
  providedIn: 'root',
})
export class GenerateXlsxCasesResumeService {
  constructor(public snackbar: MatSnackBar, public casesService: CaseService) {}
  cases;
  async generate() {
    await this.casesService.getCasesResume().subscribe((response: ICase) => {
      this.cases = response;
      const nameDocument = 'Resumen Casos en el Sistema';
      const typeDocument =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const workbook = new Workbook();
      let worksheet, worksheetBancos;

      worksheet = workbook.addWorksheet(nameDocument);
      worksheetBancos = workbook.addWorksheet('casos', {
        state: 'veryHidden',
      });

      // this.buildBancosSheet(BANCOS, worksheetBancos);
      worksheet.columns = HEADER_EXCEL_CASES_RESUME;
      this.generateFakeCells(worksheet);
      // this.setAutocomplete(worksheet);
      this.setHeaderStyle(worksheet);
      this.save(workbook, typeDocument, nameDocument);
    });
  }

  buildBancosSheet(bancos, worksheetBancos) {
    const data = bancos.map((banco) => [banco.nombre]);
    worksheetBancos.addRows(data);
  }

  generateFakeCells(worksheet) {
    worksheet.addRows(this.cases).forEach(
      (row) =>
        (row.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        })
    );
  }

  setAutocomplete(worksheet) {
    this.setAutoCompleteBancos(worksheet);
  }

  setAutoCompleteBancos(worksheet) {
    const column = worksheet.getColumn('banco');
    const config = {
      type: 'list',
      formulae: ['=bancos!$A$1:$A$346'],
    };
    column.eachCell((cell) => (cell.dataValidation = config));
  }

  setHeaderStyle(worksheet) {
    worksheet.getRow(1).height = 30;
    worksheet.getRow(1).eachCell({ includeEmpty: true }, (cell) => {
      const currentCell = worksheet.getCell(cell.address);
      currentCell.fill = {
        type: 'pattern',
        pattern: 'darkTrellis',
        fgColor: { argb: '051235' },
        bgColor: { argb: '051235' },
      };
      currentCell.font = {
        color: { argb: 'ffffff' },
        bold: true,
      };
    });
  }

  async save(workbook, typeDocument, nameDocument) {
    const data = await workbook.xlsx.writeBuffer();
    const blob = new Blob([data], { type: typeDocument });
    saveAs(blob, nameDocument + '.xlsx');
  }

  async readExcelFile(file) {
    const cuentas = [];
    const rows = await readXlsxFile(file);
    rows.splice(0, 1);
    for (let row of rows) {
      if (this.validateBanco(BANCOS, row[0])) {
        this.snackbar.open(
          'Error: Asegurese de que los datos sean correctos',
          '❌'
        );
        return null;
      }
      const dataRow = {
        banco: row[0],
        numero_cuenta: row[1],
      };
      cuentas.push(dataRow);
    }
    return cuentas;
  }

  validateBanco(bancos, banco) {
    const nameBancos = bancos.map((banco) => banco.nombre);
    const index = nameBancos.indexOf(banco);
    return index === -1;
  }
}
